export default __webpack_public_path__ + "static/media/dot_blue.8aef3fc1.svg";